import React from 'react';

import styles from './ForgotHelpItem.module.scss';

type ForgotHelpItemProps = {
  title: string;
  id: string;
  children: React.ReactNode;
};

const ForgotHelpItem: React.FC<ForgotHelpItemProps> = ({
  title,
  id,
  children,
}) => (
  <div id={id} className={styles.helpItem}>
    <h3 className={styles.title}>{title}</h3>
    <div className={styles.description}>{children}</div>
  </div>
);

export default ForgotHelpItem;
